import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-qualificationform',
  templateUrl: './qualificationform.component.html',
  styleUrls: ['./qualificationform.component.css']
})
export class QualificationformComponent implements OnInit {
title =  'Qualification Details';
  data: any;
  Q: any = {};
  QU_Id: number;
  mode: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.QU_Id = params['QU_Id'];
      this.mode = params['mode'];

      if (this.QU_Id > 0) {

        this.GetByIdQualificationDetails(this.QU_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Qualification ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Qualification ";
    }
  }

  CreateQualification(Qualification: NgForm) {
    debugger;
    this.data = this.userService.CreateQualification(Qualification.value);
    this.data.subscribe(
      (response) => {
        Qualification.reset();
        Qualification.resetForm();
        Qualification.form.markAsPristine();
        Qualification.form.markAsUntouched();
        swal('Success!', 'Qualification Details Added Successfully .', 'success');
        this.router.navigate(['/home/qualification']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  GetByIdQualificationDetails(QU_Id) {
    debugger;
    this.data = this.userService.GetByIdQualificationDetails(QU_Id);
    this.data.subscribe(
      (response: any) => {
        this.Q = response;
      }, (error) => {
      });
  }

  UpdateQualification(Qualification: NgForm) {
    debugger;
    this.data = this.userService.UpdateQualification(this.QU_Id,Qualification.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Qualification details updated Successfully .', 'success');
        this.router.navigate(['/home/qualification']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/qualification/qualificationform/qualificationform.component.ts